import app from 'flarum/forum/app';

export default class FileListState {
  constructor() {
    this.user = null;

    this.files = [];

    this.moreResults = false;

    this.loading = false;

    this.filesize_total = 0;
    this.filesize_free = 0;
    this.filesize_used = 0;
  }

  /**
   * Set user and load list
   *
   * @param user A user to populate the media manager
   */
  setUser(user) {
    // Keep previous state
    if (user === this.user) return;

    // Set user
    this.user = user;

    // Reset file list
    this.files = [];

    // Load user files
    this.loadResults();
  }

  /**
   * Load more user files
   *
   * @param offset The index to start the page at.
   */
  loadResults(offset = 0) {
    if (!this.user) return;

    this.loading = true;

    return app.store
      .find('fof/uploads', {
        filter: {
          user: this.user.id(),
        },
        page: {
          offset,
        },
      })
      .then(this.parseResults.bind(this));
  }

  humanlyFormat(size){
    size = parseInt(size);
    if(size == -1){
      return '∞';
    }
    const levels = ['B', 'KB', 'MB', 'GB', 'TB'];
    let level = 0;
    while(size > 2048){
      size = parseFloat(size) / 1024;
      level ++;
    }
    return size.toFixed(2) + levels[level];
  }
  /**
   * Load the next page of discussion results.
   */
  loadMore() {
    this.loading = true;

    this.loadResults(this.files.length).then(this.parseResults.bind(this));
  }

  /**
   * Parse results and append them to the file list.
   */
  parseResults(results) {
    this.files.push(...results);
    this.loading = false;
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    
    this.filesize_free = results.payload.meta.filesize_free;
    this.filesize_total= results.payload.meta.filesize_total;
    if(this.filesize_free != -1){
      this.filesize_used = this.filesize_total - this.filesize_free
    }else{
      this.filesize_used = -1;
    }
    this.human_filesize_free = this.humanlyFormat(this.filesize_free);
    this.human_filesize_total = this.humanlyFormat(this.filesize_total);
    this.human_filesize_used = this.humanlyFormat(this.filesize_used);
    m.redraw();

    return results;
  }

  /**
   * Add files to the beginning of the list
   */
  addToList(files) {
    if (Array.isArray(files)) {
      this.files.unshift(...files);
      files.forEach((file) => {
        this.filesize_free -= parseInt(file.data.attributes.size);
        this.filesize_used += parseInt(file.data.attributes.size);
      })
    } else {
      this.files.unshift(files);
      this.filesize_free -= parseInt(files.data.attributes.size);
      this.filesize_used += parseInt(files.data.attributes.size);
    }
    this.human_filesize_free = this.humanlyFormat(this.filesize_free);
    this.human_filesize_total = this.humanlyFormat(this.filesize_total);
    this.human_filesize_used = this.humanlyFormat(this.filesize_used);
  }

  /**
   * Are there any files in the list?
   */
  hasFiles() {
    return this.files.length > 0;
  }

  /**
   * Is the file list loading?
   */
  isLoading() {
    return this.loading;
  }

  /**
   * Does this user has more files?
   */
  hasMoreResults() {
    return this.moreResults;
  }

  /**
   * Does this user have any files?
   */
  empty() {
    return !this.hasFiles() && !this.isLoading();
  }

  removeFile(_uuid){
    const index = this.files.findIndex((file) => _uuid === file.uuid());
    let toRemovedFile = this.files[index];
    this.files.splice(index, 1);
    this.filesize_free += parseInt(toRemovedFile.data.attributes.size);
    this.filesize_used -= parseInt(toRemovedFile.data.attributes.size);
    this.human_filesize_free = this.humanlyFormat(this.filesize_free);
    this.human_filesize_total = this.humanlyFormat(this.filesize_total);
    this.human_filesize_used = this.humanlyFormat(this.filesize_used);
  }
}
